import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { PaginatedResults } from '../../overviews/generic-overview/components/pagination/entities/paginated-results.entity';
import { PaginationInfo } from '../../overviews/generic-overview/components/pagination/entities/pagination-info.entity';
import { MetabaseReport } from '../entities/report.entity';
import { ShReportService } from '../services/report.service';

@Injectable()
export class ShReportsSandboxService {
    constructor(private readonly reportService: ShReportService) {}

    getReports(paginationInfo: PaginationInfo): Observable<PaginatedResults<MetabaseReport>> {
        return this.reportService.getAll(paginationInfo);
    }

    getReport(id: string): Observable<MetabaseReport> {
        return this.reportService.get(id);
    }
}
